export const SECRET_KEY_RE = /key|token|secret|credential|password/i;

export const SECRET_MASK = '••••••••';

export function redactSecrets(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(redactSecrets);
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([k, v]) =>
        SECRET_KEY_RE.test(k) ? [k, SECRET_MASK] : [k, redactSecrets(v)],
      ),
    );
  }
  return value;
}
